module.exports = __webpack_public_path__ + "img/znjt32.ebac35df.svg";